import * as React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, Typography, DialogActions, List, ListSubheader, CircularProgress } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { reservation } from '../../../../model/reservation';
import { IMediaQueryProps, WithMediaQuery } from '../../../../layout/withMediaQuery';
import CancelButton from '../../../../ui-components/Button/CancelButton';
import { contact } from '../../../../model/contact';
import { styles } from '../../styles';
import { IApplicationState } from '../../../../store/ApplicationState';
import { IState as IRoomState } from '../../../room/store/state';
import { IActions as IRoomActions, actionCreator as roomActions } from '../../../room/store/action/creators';
// import { IState as IActivityState } from '../../../activities/store/state';
// import { IActions as IActivityActions, actionCreator as activityActions } from '../../../activities/store/actions/creators';
import { IActions as IContactActions, actionCreator as contactActions } from '../../../../common/store/contacts/actions/creators';
import { connect } from 'react-redux';
import { INormalizedObjects, NormalizedObjectsFactory } from '../../../../common/interfaces/INormalizedObject';
import ContactReservationItem from './ContactReservationItem';
import { Alert } from '@material-ui/lab';

interface IProps extends IMediaQueryProps, IRoomActions, IRoomState, IContactActions, IInnerProps {
    // IActivityActions, IActivityState, 
}

interface IInnerProps extends StyledComponentProps {
    onCancel: () => any;
    open: boolean;
    contact: contact;
    loadingReservations: boolean;
    isContactReservationFetchInError: boolean;
    reservations: reservation[];
}
interface IInnerState {
    reservationList: INormalizedObjects<reservation[]>;
}



class ContactReservationDialog extends React.Component<IProps, IInnerState> {

    /**
     *
     */
    constructor(p, c) {
        super(p, c);
        this.state = {
            reservationList: NormalizedObjectsFactory()
        }
    }


    getContactDescription = (contact: contact) => {
        return contact.surname ? (contact.surname + " " + contact.name) : contact.email;
    }

    componentDidMount() {
        if (!this.props.rooms || this.props.rooms.length === 0) {
            this.props.loadRooms();
        }
        // if (!this.props.allActivities || this.props.allActivities.length === 0) {
        //     this.props.loadActivities();
        // }
    }
    componentDidUpdate(prevProps: IInnerProps) {
        if (this.props.reservations.length !== prevProps.reservations.length) {
            this.setState({
                reservationList: this.groupRevervationByRoomId(this.props.reservations),
            });
        }
    }

    groupRevervationByRoomId = (reservations: reservation[]) => {
        let group = NormalizedObjectsFactory();
        reservations.forEach(r => {
            if (group.byId[r.roomId] === undefined) {
                group.allIds.push(r.roomId);
                group.byId[r.roomId] = [r];
            } else {
                group.byId[r.roomId].push(r);
            }
        })
        return group;
    }


    render() {
        const { classes } = this.props;
        return (
            <Dialog
                open={this.props.open}
                onClose={(e) => this.props.onCancel()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">Prenotazioni di {this.getContactDescription(this.props.contact)}</DialogTitle>}
                < DialogContent className={this.props.classes.reservationSlotDetailDialogContent} >
                    <Grid container justify={"center"}>
                        {this.props.loadingReservations ?
                            <Grid item xs={12} style={{ display: 'flex' }}>
                                <CircularProgress size={80} />
                            </Grid>
                            : (this.props.isContactReservationFetchInError ?
                                <Grid item xs={12}>
                                    <Alert severity="error">Error while fetching user's reservations</Alert>
                                </Grid>
                                : <>
                                    <Grid item xs={12}>
                                        <Typography>Prenotazioni attive: {this.props.reservations.length}</Typography>
                                    </Grid>
                                    <List className={this.props.classes.contactReservationsList}>
                                        {this.state.reservationList.allIds.map((roomId) => {

                                            let roomSubHeader = this.props.rooms.find(room => room._id === roomId);
                                            let reservations = this.state.reservationList.byId[roomId];

                                            return (<li key={`section-${roomId}`} className={classes.listSection}>
                                                <ul className={classes.listSubheaderContainer}>
                                                    <ListSubheader className={classes.listSubheader}>{roomSubHeader ? `${roomSubHeader.description}` : "Attività"}</ListSubheader>
                                                    {reservations.map((item) => (
                                                        <ContactReservationItem key={`key-${item._id}`} reservation={item} />
                                                    ))}
                                                </ul>
                                            </li>)
                                        })}
                                    </List>
                                </>)}
                    </Grid>
                </DialogContent >
                <DialogActions className={this.props.classes.contactReservationDialogActions}>
                    <CancelButton onClick={this.props.onCancel} />
                </DialogActions>
            </Dialog >
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
    return {
        ...ownProps,
        // ...state.activities,
        ...state.rooms
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    ...roomActions(dispatch),
    // ...activityActions(dispatch),
    ...contactActions(dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles as any)(WithMediaQuery(ContactReservationDialog))) as React.ComponentType<IInnerProps>;